import { generatePath } from 'react-router-dom';
import { routes } from '@/constants';
import type { ClientProperty } from '@/api/types';

export const LOCATION_SEARCH_THRESHOLD = 10;

export interface ApplicableLocation {
  id: number;
  name: string;
  address: string;
  rolesCount: number;
}

export function toApplicableLocations(
  properties: ClientProperty[] | undefined
): ApplicableLocation[] {
  // TEMPORARY: the API doesn't return per-property `id` yet — use the list index
  // so the location step is completable. Revert to `id: p.id` once real ids ship.
  return (properties ?? [])
    .map((p) => ({
      id: p.id,
      name: p.name,
      address: p.address,
      rolesCount: (p.positions ?? []).filter((pos) => pos.visible).length,
    }))
    .filter((location) => location.rolesCount > 0);
}

export function filterLocations(
  locations: ApplicableLocation[],
  query: string
): ApplicableLocation[] {
  const q = query.trim().toLowerCase();
  if (!q) return locations;
  return locations.filter(
    (l) => l.name.toLowerCase().includes(q) || l.address.toLowerCase().includes(q)
  );
}

export function shouldShowSearch(count: number): boolean {
  return count > LOCATION_SEARCH_THRESHOLD;
}

export function applyFormPath(id: number): string {
  return generatePath(routes.applyForm, { property_id: String(id) });
}
